import React from 'react';
import { FloatingMenu, SystemText } from 'e4shared';

export const PeriodSelector = ({ range, setRange, offset, setOffset, hideWeekly, className, white, ...extra }) => {
    const [buttonText, setButtonText] = React.useState('');

    React.useEffect(() => {
        setButtonText(SystemText('User121/PeriodSelector/Buttons/ThisMonth'));
    }, []);

    const setPeriod = (r, o) => {
        setRange(r);
        setOffset(o);
        setButtonText(`${o === 1 ? 'Last' : 'This'} ${r}`);
    };

    const checkPeriod = (r, o) => {
        return range === r && offset === o;
    };

    const buttonOptions = [
        { label: SystemText('User121/PeriodSelector/Buttons/ThisQuarter'), range: 'quarter', offset: 0 },
        { label: SystemText('User121/PeriodSelector/Buttons/LastQuarter'), range: 'quarter', offset: 1 },
        { label: SystemText('User121/PeriodSelector/Buttons/ThisMonth'), range: 'month', offset: 0 },
        { label: SystemText('User121/PeriodSelector/Buttons/LastMonth'), range: 'month', offset: 1 },
        { label: SystemText('User121/PeriodSelector/Buttons/ThisWeek'), range: 'week', offset: 0, disabled: hideWeekly },
        { label: SystemText('User121/PeriodSelector/Buttons/LastWeek'), range: 'week', offset: 1, disabled: hideWeekly },
    ];

    const cs = className ? className : 'btn-row pull-right text-right hidden-xs title-floatingmenu';

    return (
        <div className="flex flex-center" {...extra}>
            <span className={cs}>
                <FloatingMenu buttonText={buttonText} small className={white ? 'btn' : ''}>
                    {buttonOptions.map(o => {
                        if (o.disabled) return null;
                        return (
                            <li
                                data-testid={`period-${o.range}-${o.offset}-select`}
                                className={checkPeriod(o.range, o.offset) ? 'selected' : ''}
                                key={`btn-option-${o.range}-${o.offset}`}
                                id={`option-${o.range}-${o.offset}`}
                                onClick={() => setPeriod(o.range, o.offset)}
                            >
                                {o.label}
                            </li>
                        );
                    })}
                    {hideWeekly && (
                        <li className="add-new">
                            <div className="text-danger text-center">
                                {SystemText('User121/PeriodSelector/NoWeekly/Line1')}
                                <br />
                                {SystemText('User121/PeriodSelector/NoWeekly/Line2')}
                                <br />
                                {SystemText('User121/PeriodSelector/NoWeekly/Line3')}
                            </div>
                        </li>
                    )}
                </FloatingMenu>
            </span>
        </div>
    );
};

export default PeriodSelector;
